import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function MemberRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return <div className="flex min-h-screen items-center justify-center bg-ivory text-anthracite/40">…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
